var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.09188 19.3369L5.978 23.4951L1.90681 23.5813C0.690125 21.3246 0 18.7426 0 15.9989C0 13.3457 0.64525 10.8437 1.789 8.64062H1.78988L5.41438 9.30512L7.00213 12.9079C6.66981 13.8767 6.48869 14.9167 6.48869 15.9989C6.48881 17.1734 6.70156 18.2987 7.09188 19.3369Z",
    fill: "#8e4f59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7205 13.0117C31.9042 13.9796 32.0001 14.9792 32.0001 16.0007C32.0001 17.1462 31.8796 18.2636 31.6502 19.3414C30.8713 23.0091 28.8361 26.2117 26.0168 28.4781L26.0159 28.4772L21.4507 28.2443L20.8046 24.2108C22.6753 23.1137 24.1373 21.3968 24.9074 19.3414H16.3518V13.0117H25.0322H31.7205Z",
    fill: "#8e4f59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0157 28.4783L26.0166 28.4792C23.2747 30.6831 19.7916 32.0018 15.9999 32.0018C9.90674 32.0018 4.60918 28.5961 1.90674 23.5842L7.0918 19.3398C8.44299 22.946 11.9217 25.513 15.9999 25.513C17.7529 25.513 19.3951 25.0392 20.8043 24.2119L26.0157 28.4783Z",
    fill: "#8e4f59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2128 3.6835L21.0295 7.927C19.5711 7.01538 17.8471 6.48875 16.0001 6.48875C11.8295 6.48875 8.28575 9.17356 7.00225 12.909L1.78994 8.64175H1.78906C4.45194 3.50769 9.81631 0 16.0001 0C19.8823 0 23.4418 1.38288 26.2128 3.6835Z",
    fill: "#8e4f59"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.c153476ffc4752a2ad802395c1633697.svg";
export { ForwardRef as ReactComponent };